import { Navigate } from "react-router";
import { useGetScopeGroupQuery } from "../../../apis/ScopeGroup.api";
import { PrimaryScopeGroup, ScopeGroup } from "../../../types/models/ScopeGroup";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const ScopeGroupScoped = () => {
    const {
        data,
    } = useGetScopeGroupQuery(PrimaryScopeGroup.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/scope-groups/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default ScopeGroupScoped;
